import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { WorkflowOverlayComponent } from 'commons/components';
import styled from 'styled-components';

export const MaterialDefinitionWorkflowOverlay = styled(WorkflowOverlayComponent)`
    div[slot='content'] {
        display: flex;
        flex-direction: column;
        background-color: ${owcTheme['one-color-gray-50']} !important;
    }
`;

export const MaterialDefinitionFormContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    padding: 2rem;
    overflow: auto;
`;

export const MaterialDefinitionFormCard = styled(PocCard)`
    width: 600px;

    /* OWC-OVERRIDE: stack the form fields with the card's v6 padding. owc-card's content
       wrapper is a plain block with zero padding in v7.6.0 and exposes no layout or padding
       prop. */
    > .owc-card__content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1.5rem;
    }

    owc-input,
    owc-select-dropdown {
        width: 100%;
    }
`;

export const MaterialDefinitionFormCardContent = styled.div`
    display: flex;
    flex-direction: column;
`;
